import { defineStore } from 'pinia'

export const useAgentStore = defineStore('agent', {
  state: () => ({
    isLoaded: false,
    level: '',
    status: 3, // 0=待审核，1=审核通过，2=审核未通过，3=未申请
    isAgent: false,
    ancestorID: null,
    agentID: null,
    mobile: '',
    ExpiryTime: '',
    isRealName: false,
  }),
  actions: {
    async fetchAgentStatus() {
      const { data, error } = await useApiFetch('/agent/info').get().json()

      if (data.value && !error.value) {
        if (data.value.code === 200) {
          this.level = data.value.data.level
          this.isAgent = data.value.data.is_agent // 判断是否是代理
          this.status = data.value.data.status // 获取代理状态  0=待审核，1=审核通过，2=审核未通过，3=未申请
          this.agentID = data.value.data.agent_id
          this.mobile = data.value.data.mobile
          this.ExpiryTime = data.value.data.expiry_time
          this.isRealName = data.value.data.is_real_name
          // 保存到localStorage
          localStorage.setItem(
            'agentInfo',
            JSON.stringify({
              isAgent: this.isAgent,
              level: this.level,
              status: this.status,
              agentID: this.agentID,
              mobile: this.mobile,
              ExpiryTime: this.ExpiryTime,
              isRealName: this.isRealName,
            })
          )
        } else {
          console.log('Error fetching agent info', data.value)
        }
      }
      this.isLoaded = true
    },

    // 更新代理信息
    updateAgentInfo(agentInfo) {
      if (agentInfo) {
        this.isAgent = agentInfo.isAgent || false
        this.level = agentInfo.level || ''
        this.status = agentInfo.status || 3
        this.agentID = agentInfo.agentID || null
        this.mobile = agentInfo.mobile || ''
        this.isLoaded = true
        this.isRealName = agentInfo.isRealName || false
      }
    },

    // 重置代理信息
    resetAgent() {
      this.isLoaded = false
      this.level = ''
      this.status = 3
      this.isAgent = false
      this.ancestorID = null
      this.agentID = null
      this.mobile = ''
      this.isRealName = false
    },
  },
})
